module.exports = __webpack_public_path__ + "static/gogs-76ed1e54e00ee94bd53fcf2473bbea5d.png";